import { TEST_PERIOD, type TestPeriod } from '../constants/test-period';

export interface DateRange {
  startDate: string;
  endDate: string;
}

const DAYS_IN_WEEK = 7;

function toDateOnly(date: Date): string {
  return date.toISOString().slice(0, 10);
}

function getCurrentWeek(now: Date): DateRange {
  const sunday = new Date(
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()),
  );
  sunday.setUTCDate(sunday.getUTCDate() - sunday.getUTCDay());
  const saturday = new Date(sunday);
  saturday.setUTCDate(sunday.getUTCDate() + DAYS_IN_WEEK - 1);
  return { startDate: toDateOnly(sunday), endDate: toDateOnly(saturday) };
}

function getCurrentMonth(now: Date): DateRange {
  const firstDay = new Date(
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1),
  );
  const lastDay = new Date(
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth() + 1, 0),
  );
  return { startDate: toDateOnly(firstDay), endDate: toDateOnly(lastDay) };
}

// Test periods run on UTC days, so the range is built from UTC parts.
export function getCurrentTestPeriodRange(
  period: TestPeriod,
  now: Date = new Date(),
): DateRange {
  if (period === TEST_PERIOD.MONTHLY) return getCurrentMonth(now);
  return getCurrentWeek(now);
}
